export default "__VITE_ASSET__CCimujAE__"